module.exports = __webpack_public_path__ + "media/assets/platinumTag-3e9e9691502e95e5fbbd822bf4aa1770.png";